const styles = (theme) => ({
  paperFluxo: {
    borderRadius: "16px",
    flex: 1,
    height: "100%",
    overflowY: "auto",
    position: "relative",
    p: 1,
  },
});

export default styles;
